import { EyeIcon } from '@heroicons/react/24/solid'
import { EmptyValuePlaceholder } from '@/components/ui'

export default ({item}) => {
  const handleDownload = (e) => {
    e.preventDefault()
    e.stopPropagation()
    window.open(item.file.url, '_blank')
  }
  return (
    <div key={item.id} className="space-x-2" data-id={item.id} data-object='document'>
      <EmptyValuePlaceholder value={item.titre} />
      { item.file && (
        <button 
          onClick={handleDownload}
          className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
          title={`Voir le document`} aria-label={`Voir le document`}
        >
          <EyeIcon/>
        </button>
      )}
    </div>
  )
}
